import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from 'src/app/shared/services/app.service';

export interface Language {
  longName: string,
  shortName: string,
  image: string
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  languages: Language[] = [{longName: "English", shortName: "en", image: "../../../assets/images/flags/en.svg"}, {longName: "Français", shortName: "fr", image: "../../../assets/images/flags/fr.svg"}, {longName: "Nederlands", shortName: "nl", image: "../../../assets/images/flags/nl.svg"}]
  selectedLanguage: Language;

  constructor(public translate: TranslateService, private appService: AppService) { }

  ngOnInit(): void {
    let browserLanguage = navigator.language;

    if(browserLanguage.startsWith("en")){
      this.selectedLanguage = this.languages[0];
      
    } else if(browserLanguage.startsWith("fr")){
      this.selectedLanguage = this.languages[1];
    } else if(browserLanguage.startsWith("nl")){
      this.selectedLanguage = this.languages[2];
    } else{
      this.selectedLanguage = this.languages[0];
    }

    this.translate.currentLang = this.selectedLanguage.shortName;
    this.translate.use(this.selectedLanguage.shortName);
    this.appService.setLanguage(this.selectedLanguage.shortName);
  }

  switchLang(lang: string) {
    this.languages.forEach(language => {
      if (language.shortName == lang) {
        this.selectedLanguage = language;
      }
    });
    this.translate.use(lang);
    this.translate.currentLang = lang;
    this.appService.setLanguage(lang);
  }

}
